import { MenuItem, Select } from "@mui/material";
import { useCallback } from "react";
import { filterFieldOperators, mapBooleanOperator } from "../../../segment-operation/operators";

import type { Condition } from "../../../../types/segment-schema";
import type { BooleanOperator } from "../../../segment-operation/operators";
import type { SelectChangeEvent } from "@mui/material";
import type { FC } from "react";

export const BooleanSelect: FC<{
  condition: Condition;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
}> = ({ condition, handleFieldChange, disabled }) => {
  const onChange = useCallback(
    (event: SelectChangeEvent) =>
      // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      handleFieldChange(mapToOperatorAndCondition(event.target.value as BooleanOperator)),
    [handleFieldChange],
  );

  return (
    <>
      <Select
        size="small"
        variant="outlined"
        label="Operator"
        onChange={onChange}
        labelId="operator-label"
        value={mapBooleanOperator(condition)}
        disabled={disabled}
      >
        {filterFieldOperators.BOOLEAN.operators.map((operatorInfo) => (
          <MenuItem key={operatorInfo.operator} value={operatorInfo.operator}>
            {operatorInfo.label()}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

function mapToOperatorAndCondition(operator: BooleanOperator): Partial<Condition> {
  switch (operator) {
    case "IS TRUE":
      return {
        operation: "IS",
        values: ["true"],
      };
    case "IS FALSE":
      return { operation: "IS", values: ["false"] };
    default:
      throw new Error("Invalid operator");
  }
}
